import { SxProps, Theme } from '@mui/material/styles';

export const drawingDisplayRootSx = {
  position: 'relative',
  height: '100%',
  minHeight: '100%',
  width: '100%',
  alignSelf: 'stretch',
  flex: '1 1 auto',
  overflow: 'hidden',
} satisfies SxProps<Theme>;

export const drawingDisplayProbeImageSx = {
  opacity: 0,
} satisfies SxProps<Theme>;
